const select2 = (editor) => {
  editor.BlockManager.add(`select2`, {
    label: `Select2`,
    category: `Forms `,
    content: `<div class='mb-3 d-flex align-items-center'>
    <select advanceSelect2='true' class='form-select' name="selectionValue">
      <option dataItem='true' value="v1">Volvo</option>
      <option dataItem='true' value="v2">Saab</option>
      <option dataItem='true' value="v3">Opel</option>
      <option dataItem='true' value="v4">Audi</option>
    </select>
    <button class="btn btn-primary pointer ml-2">update</button>
    </div>
    `,
    attributes: { dataItem: 'true', class: 'fa fa-plus-square' }
  });
};

export default select2;
